/* ==========================================================================
   1. DATA & CONFIGURATION
   ========================================================================== */
const COMMON_LABEL_URL = "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/nutrition-panel.png?v=1770116426";

const NUTRITION_DATA = [
    { name: "Strawberry Strike", img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Strawberry_ee9d8999-65de-4f57-80d1-c3f61e0db5ad.png?v=1770114517", label: COMMON_LABEL_URL, ingredients: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Strawberry Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color" },
    { name: "Green Apple Rattle", img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Apple_6aa95aee-ed2a-40a9-9617-530f93e90976.png?v=1770114513", label: COMMON_LABEL_URL, ingredients: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Apple and Peach Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color" },
    { name: "Breach Peach", img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Peach_8864e169-899f-44c0-9d12-9eefe3a75d6f.png?v=1770114513", label: COMMON_LABEL_URL, ingredients: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Peach Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color" }
];

const FLAVOR_DATA = {
    strawberry: { title: "Strawberry Strike", img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/strawberry-large.png?v=1771480829", bg: "#f8d7da", ing: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Strawberry Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color." },
    apple: { title: "Green Apple Rattle", img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/apple-large.png?v=1771481007", bg: "#e2f3e2", ing: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Apple and Peach Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color." },
    peach: { title: "Breach Peach", img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/peach-large.png?v=1771480828", bg: "#fff3cd", ing: "Tapioca Syrup, Allulose, Water, Organic Cane Sugar, Pectin, Peach Organic Flavor, Citric Acid, Malic Acid, White Rice Flour, Sodium Malate, Sodium Citrate, Monk Fruit Extract, Organic Fruit and Vegetable Juice for Color." },
    mix: { title: "Morale Mix", img: "https://cdn.shopify.com/s/files/1/0491/5645/6601/files/mix-large.png?v=1771480828", bg: "#e9ecef", ing: "Mix of bag of each flavor." }
};

/* ==========================================================================
   2. CAROUSEL LOGIC
   ========================================================================== */
let currentImgIndex = 0;
const slides = document.querySelectorAll('.c-img');
const thumbs = document.querySelectorAll('.thumb');

window.changeSlide = function(step) {
    let newIndex = currentImgIndex + step;
    if (newIndex >= slides.length) newIndex = 0;
    if (newIndex < 0) newIndex = slides.length - 1;
    goToSlide(newIndex);
};

window.goToSlide = function(index) {
    if (!slides.length) return;
    currentImgIndex = index;
    slides.forEach(s => s.classList.remove('active'));
    slides[index].classList.add('active');
    thumbs.forEach(t => t.classList.remove('active'));
    if(thumbs[index]) {
        thumbs[index].classList.add('active');
        thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
};

/* ==========================================================================
   3. REAL REVIEW INJECTOR
   ========================================================================== */
function injectRealReview() {
    const checkInterval = setInterval(() => {
        const reviewItems = document.querySelectorAll('#customer-reviews .jdgm-carousel-item');
        if (reviewItems.length > 0) {
            clearInterval(checkInterval);
            
            const randomIndex = Math.floor(Math.random() * reviewItems.length);
            const realReview = reviewItems[randomIndex];

            const name = realReview.querySelector('.jdgm-carousel-item__reviewer-name')?.innerText || 'Verified Buyer';
            const title = realReview.querySelector('.jdgm-carousel-item__review-title')?.innerText || 'Great Product';
            const body = realReview.querySelector('.jdgm-carousel-item__review-body')?.innerText || '';
            const ratingHtml = realReview.querySelector('.jdgm-carousel-item__review-rating')?.innerHTML;

            document.getElementById('r-name').innerText = name;
            document.getElementById('r-title').innerText = title;
            document.getElementById('r-body').innerText = `"${body.trim()}"`;
            
            const starsEl = document.getElementById('r-stars');
            if(starsEl && ratingHtml) starsEl.innerHTML = ratingHtml;

            const avatarBox = document.getElementById('r-avatar-box');
            if (avatarBox) {
                avatarBox.style.backgroundColor = '#3d594f';
                avatarBox.innerHTML = `
                  <img 
                    src="https://cdn.shopify.com/s/files/1/0491/5645/6601/files/Tactical_Snacks_R5-01.png?v=1770039912" 
                    id="r-avatar-icon"
                    style="width:auto; object-fit:contain;"
                  >
                `;
            }
        }
    }, 500);
    setTimeout(() => clearInterval(checkInterval), 8000);
}

/* ==========================================================================
   4. DOM INIT (ALL FEATURES)
   ========================================================================== */
document.addEventListener("DOMContentLoaded", function() {
    
    // 1. Init Carousel
    goToSlide(0);

    // 2. Init Review Injection
    injectRealReview();

    // 3. Init Date
    const dateEl = document.getElementById('dynamic-offer-date');
    if(dateEl) {
        const d = new Date();
        const suffix = (day) => { if(day>3&&day<21)return'th';switch(day%10){case 1:return"st";case 2:return"nd";case 3:return"rd";default:return"th";}};
        dateEl.innerText = d.toLocaleDateString('en-US', {month:'short', day:'numeric'}) + suffix(d.getDate());
    }

    // 4. Init Default Bundle
    setTimeout(() => {
        const defCard = document.querySelector('.bundle-card[data-bundle-qty="3"]');
        if (defCard) window.selectBundle(defCard);
    }, 50);

    // 5. Init Timer
    const timerBox = document.getElementById('valentine-timer');
    if (timerBox) {
      let timeLeft = 43200; // 12 hours
      setInterval(() => {
          timeLeft--; if(timeLeft < 0) timeLeft = 43200;
          const h = Math.floor(timeLeft / 3600).toString().padStart(2,'0');
          const m = Math.floor((timeLeft % 3600) / 60).toString().padStart(2,'0');
          const s = (timeLeft % 60).toString().padStart(2,'0');
          document.getElementById('vd-hrs').innerText = h;
          document.getElementById('vd-min').innerText = m;
          document.getElementById('vd-sec').innerText = s;
      }, 1000);
    }

    // 6. Init Nutrition Accordion (Left Column Widget)
    const nutHead = document.querySelector('.nutrition-accordion-head');
    const nutBody = document.querySelector('.nutrition-accordion-body');
    if(nutHead && nutBody) {
        nutHead.addEventListener('click', () => {
            nutBody.style.display = nutBody.style.display === 'block' ? 'none' : 'block';
        });
    }

    // 7. Init FAQ Accordion
    document.querySelectorAll('.javvy-faq-item').forEach(item => {
        const head = item.querySelector('.javvy-faq-head');
        if(head) {
            head.addEventListener('click', () => {
                item.classList.toggle('is-open');
            });
        }
    });

    // 8. Video Auto-Play & Click Logic
    const videos = document.querySelectorAll('.javvy-video-player');
    const obs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
            const wrapper = e.target.closest('.javvy-video-wrapper');
            if(e.isIntersecting) {
                e.target.play();
                if(wrapper) wrapper.classList.add('is-playing');
            } else {
                e.target.pause();
                if(wrapper) wrapper.classList.remove('is-playing');
            }
        });
    }, {threshold: 0.5});
    videos.forEach(v => obs.observe(v));

    // Manual Click to Pause/Play
    document.querySelectorAll('.javvy-video-wrapper').forEach(wrapper => {
        const video = wrapper.querySelector('video');
        wrapper.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                wrapper.classList.add('is-playing');
            } else {
                video.pause();
                wrapper.classList.remove('is-playing');
            }
        });
    });

    // 9. Sticky Bar Visibility
    const stickyBar = document.getElementById('javvy-sticky-atc');
    const mainCta = document.getElementById('main-bundle-cta');
    const stickyBtn = document.getElementById('sticky-proxy-btn');

    if (stickyBar && mainCta) {
        window.addEventListener('scroll', () => {
            const rect = mainCta.getBoundingClientRect();
            if (rect.bottom < 0) stickyBar.classList.add('is-visible');
            else stickyBar.classList.remove('is-visible');
        });
    }

    // 10. Buy Button Listeners & Perfect Mirror Sync
    if (mainCta && stickyBtn) {
        // A. Click Listeners
        mainCta.addEventListener('click', (e) => {
            e.preventDefault();
            proceedToCheckout();
        });
        stickyBtn.addEventListener('click', (e) => {
            e.preventDefault();
            proceedToCheckout();
        });

        // B. The Mirror Function
        function syncStickyButton() {
            // Copy HTML (prices, text, loaders)
            stickyBtn.innerHTML = mainCta.innerHTML;
            // Copy disabled states
            stickyBtn.disabled = mainCta.disabled;
            // Copy the hidden quantity attribute so checkout works correctly
            if (mainCta.hasAttribute('data-qty')) {
                stickyBtn.setAttribute('data-qty', mainCta.getAttribute('data-qty'));
            }
        }

        // Run once immediately on load
        syncStickyButton();

        // C. The Mutation Observer (Watches for any changes and syncs instantly)
        const observer = new MutationObserver(syncStickyButton);
        observer.observe(mainCta, { attributes: true, childList: true, subtree: true });
    }

    // 11. Mobile Layout Rearrangements
    if (window.innerWidth <= 768) {
        
        // A. Move review card & nutrition link directly under the sub-disclaimer
        const subLinksContainer = document.querySelector('.sub-footer-links');
        const reviewCard = document.querySelector('.javvy-review-card');
        const nutLink = document.querySelector('.nutrition-link-wrapper');
        
        if (subLinksContainer && reviewCard && nutLink) {
            subLinksContainer.appendChild(reviewCard);
            reviewCard.style.marginTop = '25px'; // Add some breathing room above the card
            subLinksContainer.appendChild(nutLink);
        }

        // B. Move the review stars directly under the carousel and center it
        const carouselContainer = document.querySelector('.javvy-carousel-container');
        const mobileReviewLink = document.querySelector('.javvy-mobile-title-block a'); 
        
        if (carouselContainer && mobileReviewLink) {
            mobileReviewLink.style.justifyContent = 'center';
            mobileReviewLink.style.margin = '15px 0 5px 0';
            // Insert right after the carousel
            carouselContainer.parentNode.insertBefore(mobileReviewLink, carouselContainer.nextSibling);
        }
    }
});

/* ==========================================================================
   5. GLOBAL HELPER FUNCTIONS
   ========================================================================== */
function updateGifts(qty, isOTP) {
    ['gift-patch', 'gift-shipping', 'gift-apparel'].forEach(id => {
        const el = document.getElementById(id);
        if(el) { el.classList.add('is-locked'); el.classList.remove('is-unlocked'); }
    });
    if (isOTP) return; 
    if (qty >= 1) document.getElementById('gift-patch')?.classList.replace('is-locked', 'is-unlocked');
    if (qty >= 3) document.getElementById('gift-shipping')?.classList.replace('is-locked', 'is-unlocked');
    if (qty >= 6) document.getElementById('gift-apparel')?.classList.replace('is-locked', 'is-unlocked');
}

window.selectBundle = function(card) {
    document.querySelectorAll('.bundle-card').forEach(c => c.classList.remove('active'));
    card.classList.add('active');
    const qty = parseInt(card.getAttribute('data-bundle-qty')) || 1;
    const subPrice = parseFloat(card.getAttribute('data-sub-price')) || 0;
    const otpPrice = parseFloat(card.getAttribute('data-onetime-price')) || 0;
    const btn = document.getElementById('main-bundle-cta');
    if (btn) {
        btn.setAttribute('data-qty', qty);
        btn.querySelector('.total-new').innerText = '$' + subPrice.toFixed(2);
        btn.querySelector('.total-old').innerText = '$' + otpPrice.toFixed(2);
    }
    const otpLink = document.getElementById('direct-otp-link');
    const otpDisp = document.getElementById('otp-price-display');
    
    // CHANGED: Redirects to the new Non-Subscription box builder passing the quantity
    if(otpLink) otpLink.href = `https://tactical-snacks.com/products/tactical-snacks-your-first-flavor-box?boxes=${qty}`;
    
    if(otpDisp) otpDisp.innerText = '$' + otpPrice.toFixed(2);
    updateGifts(qty, false);
};

function proceedToCheckout() {
    const btn = document.getElementById('main-bundle-cta');
    const stickyBtn = document.getElementById('sticky-proxy-btn'); // Target the sticky button
    
    if (!btn) return;
    
    // 1. Add loading state classes
    btn.classList.add('is-loading');
    if (stickyBtn) stickyBtn.classList.add('is-loading');
    
    // 2. Force hide all text and spans (except the loader)
    btn.style.color = "transparent";
    Array.from(btn.children).forEach(child => {
        if (!child.className.includes('loader')) child.style.opacity = '0';
    });

    if (stickyBtn) {
        stickyBtn.style.color = "transparent";
        Array.from(stickyBtn.children).forEach(child => {
            if (!child.className.includes('loader')) child.style.opacity = '0';
        });
    }
    
    // 3. Redirect to checkout
    const qty = btn.getAttribute('data-qty') || 3;
    const baseUrl = "https://tactical-snacks.com/products/tactical-snacks-try-your-first-flavor-box";
    window.location.href = `${baseUrl}?boxes=${qty}&mode=sub`;
}

window.openFlavorModal = function(key) {
    const data = FLAVOR_DATA[key];
    const modal = document.getElementById('flavorModal');
    if(!modal || !data) return;
    document.getElementById('modalFlavorName').innerText = data.title;
    document.getElementById('modalHeaderImg').style.backgroundImage = `url(${data.img})`;
    document.getElementById('modalHeaderImg').style.backgroundColor = data.bg;
    document.getElementById('modalIngredients').innerText = data.ing;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden'; 
};

window.closeFlavorModal = function() {
    document.getElementById('flavorModal').style.display = 'none';
    document.body.style.overflow = ''; 
};

window.toggleModalLabel = function() {
    const content = document.getElementById('modalLabelContent');
    content.style.display = content.style.display === 'block' ? 'none' : 'block';
};

window.scrollToFlavors = function() {
    const section = document.getElementById('javvy-section-flavors');
    if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
};